// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SubscribedPhotoblogs":"sv_a bhg_b bhg_bj","SubscribedPhotoblogs__link":"sv_b bhg_a bhg_r"};